<template>
  <div class="product-btn">
    <a @click="addToCart" ><i class="ion-plus" ></i>{{descr}}</a>
  </div>
</template>


<script>
import Vue from 'vue';
  import {
    ADD_TO_CART,
    REMOVE_FROM_CART
  } from '../../store/mutation-types'

  export default {
    props: ['product', 'descr'],
    data () {
      return {
        cart: this.$store.state.cart
      }
    },
    computed: {
      isAdding () {
        return this.cart.indexOf(this.product) < 0
      },
      getColorApp () {
           return Vue.$storeSettings.ColorApp;
       }
    },
    methods: {
      addToCart () {

        if (this.hasPackageData ())
        {
           for (var i = 0; i < this.product.Childs.length; i++)
           {
              var a = this.product.Childs[i];
              a.PackageID = this.product.ArticleID;
              this.$store.commit(ADD_TO_CART, a)
           }
        }
        else
        {
           this.$store.commit(ADD_TO_CART, this.product)
        }
        
        this.$router.push ("/cart");
      },
      removeFromCart (id) {
        this.$store.commit(REMOVE_FROM_CART, id)
      },
      hasPackageData () {
         if (this.product.Childs == null) {return false;}
         if (this.product.Childs.length > 0) {return true;}
         return false;
       },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/products/ProductButton.vue